import router from "@/lib/router";
import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.externalTables": "Tables externes",
			"breadcrumb.externalTables.create": "Créer une table externe",
			"breadcrumb.externalTables.edit": "Modifier une table externe",
			"breadcrumb.externalTableVersions": "Versions de table externe",
			"breadcrumb.externalTableVersions.create": "Créer une version de table externe",
			"breadcrumb.externalTableVersions.edit": "Modifier une version de table externe",
			"breadcrumb.externalTableRows": "Lignes de version de table externe",
			"breadcrumb.externalTableQueries": "Requêtes de tables externes",
			"breadcrumb.externalTableQueries.create": "Créer une requête de table externe",
			"breadcrumb.externalTableQueries.edit": "Modifier une requête de table externe"
		});

		breadcrumb.add([
			{
				path: "/database/externalTables",
				name: "home>database>externalTables"
			},
			{
				path: "/database/externalTables/create",
				name: "home>database>externalTables>externalTables.create"
			},
			{
				path: "/database/externalTables/([0-9]+)/edit",
				name: "home>database>externalTables>externalTables.edit",
				replacePath: "/database/externalTables/{1}/edit"
			},
			{
				path: "/database/externalTables/queries",
				name: "home>database>externalTables>externalTableQueries"
			},
			{
				path: "/database/externalTables/queries/create",
				name: "home>database>externalTables>externalTableQueries>externalTableQueries.create"
			},
			{
				path: "/database/externalTables/queries/([0-9]+)",
				name: "home>database>externalTables>externalTableQueries>externalTableQueries.edit",
				replacePath: "/database/externalTables/queries/{1}"
			},
			{
				path: "/database/externalTables/([0-9]+)/versions",
				name: "home>database>externalTables>externalTableVersions",
				replacePath: "/database/externalTables/{1}/versions"
			},
			{
				path: "/database/externalTables/([0-9]+)/versions/create",
				name: "home>database>externalTables>externalTableVersions>externalTableVersions.create",
				replacePath: "/database/externalTables/{1}/versions/create"
			},
			{
				path: "/database/externalTables/([0-9]+)/versions/([0-9]+)/edit",
				name: "home>database>externalTables>externalTableVersions>externalTableVersions.edit",
				replacePath: "/database/externalTables/{1}/versions/{2}/edit"
			},
			{
				path: "/database/externalTables/([0-9]+)/versions/rows",
				name: "home>database>externalTables>externalTableVersions>externalTableRows",
				replacePath: "/database/externalTables/{1}/versions/rows"
			}
		]);

		router.addRoutes([
			{
				path: "/database/externalTables",
				component: () => import("./vues/ExternalTableList.vue"),
				name: ExternalTableRouteName.LIST,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/create",
				component: () => import("./vues/ExternalTableAddEdit.vue"),
				name: ExternalTableRouteName.CREATE,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/:tableId/edit",
				component: () => import("./vues/ExternalTableAddEdit.vue"),
				name: ExternalTableRouteName.EDIT,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/queries",
				component: () => import("./vues/ExternalTableQueryList.vue"),
				name: ExternalTableQueryRouteName.LIST,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/queries/create",
				component: () => import("./vues/ExternalTableQueryAddEdit.vue"),
				name: ExternalTableQueryRouteName.CREATE,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/queries/:queryId",
				component: () => import("./vues/ExternalTableQueryAddEdit.vue"),
				name: ExternalTableQueryRouteName.EDIT,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/:tableId/versions",
				component: () => import("./vues/ExternalTableVersionList.vue"),
				name: ExternalTableVersionRouteName.LIST,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/:tableId/versions/create",
				component: () => import("./vues/ExternalTableVersionAddEdit.vue"),
				name: ExternalTableVersionRouteName.CREATE,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/:tableId/versions/:versionId/edit",
				component: () => import("./vues/ExternalTableVersionAddEdit.vue"),
				name: ExternalTableVersionRouteName.EDIT,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/externalTables/:tableId/versions/rows",
				component: () => import("./vues/ExternalTableRowList.vue"),
				name: ExternalTableVersionRouteName.ROWS,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			}
		]);
	}
}

export enum ExternalTableRouteName {
	LIST = "externalTables",
	CREATE = "externalTables.create",
	EDIT = "externalTables.edit"
}

export enum ExternalTableVersionRouteName {
	LIST = "externalTableVersions",
	CREATE = "externalTableVersions.create",
	EDIT = "externalTableVersions.edit",
	ROWS = "externalTableRows"
}

export enum ExternalTableQueryRouteName {
	LIST = "externalTableQueries",
	CREATE = "externalTableQueries.create",
	EDIT = "externalTableQueries.edit"
}
